import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material";

const StyledLink = ({
	href,
	target,
	customLinkStyle,
	children,
	state,
}) => {
	const theme = useTheme();
	const navigate = useNavigate();
	const defaultStyledLinkStyle = {
		display: "flex",
		justifyContent: "center",
		color: "black",
		backgroundColor: theme.palette.color_yellow,
		borderRadius: "6px",
		padding: "6px 8px",
		m: { xs: "5px 5px 5px 5px", md: "0 0 10px 0" },
		boxShadow: "2px 3px #888888",
		width: { xs: "100%", md: "100%", lg: "300px" },
		cursor: "pointer",
	};

	const handleNavigation = () => {
		navigate(href, { state: state });
	};

	return (
		<Link
			sx={{ ...defaultStyledLinkStyle, ...customLinkStyle }}
			onClick={() => handleNavigation()}
			target={target}
			underline="none">
			{children}
		</Link>
	);
};
export default StyledLink;
